export const rootStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
};

export const imageStyles = {
  display: 'block',
  maxWidth: '100%',
  maxHeight: 240,
  borderRadius: '6px',
  objectFit: 'cover',
};

export const fileRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const fileIconStyles = {
  color: 'text.secondary',
  display: 'flex',
};

export const fileLinkStyles = {
  color: 'inherit',
};

export const fileMetaStyles = {
  color: 'text.secondary',
};
